import { Field, FlowableValueSetRadioField } from '../../../translation/types';
import ValuesetOneCheckbox, { ConnectedComponentProps } from './';
import { ensureEndswithId, getLabel, getHtmlId, getLabelledBy, isFieldFromFlowable } from '../../fieldUtils';
import { getDefaultCode } from '../../fieldUtils/valueset';
import { getDirection } from '../../fieldUtils/checkboxAndRadio';
import { GenericProps, FormFieldItem } from '../../props';

const getValuesetCheckbox = (
    fieldDefinition: Field,
    propConfiguration: GenericProps,
): FormFieldItem<ConnectedComponentProps> => {
    return {
        Component: ValuesetOneCheckbox,
        props: {
            fetchOwnData: false,
            ...propConfiguration,
            valueSet: isFieldFromFlowable(fieldDefinition)
                ? (fieldDefinition as FlowableValueSetRadioField).params.valueSet
                : undefined,
            labelledBy: getLabelledBy(fieldDefinition),
            id: getHtmlId(fieldDefinition),
            defaultCode: getDefaultCode(fieldDefinition),
            source: ensureEndswithId(fieldDefinition.name),
            direction: getDirection(fieldDefinition),
            label: getLabel(fieldDefinition),
        },
    };
};
export default getValuesetCheckbox;
